module.exports = __webpack_public_path__ + "img/9788952222381.24d707c0.jpg";